import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export type ReportType = 'daily-performance' | 'weekly-performance' | 'patron-acquisition';
export type ReportFormat = 'json' | 'csv';

interface GenerateReportParams {
  type: ReportType;
  format?: ReportFormat;
  startDate?: string;
  endDate?: string;
}

export interface ReportResponse<T = any> {
  success: boolean;
  data: T[];
  meta: { type: string; startDate?: string; endDate?: string };
}

function authHeaders() {
  const token = localStorage.getItem('accessToken');
  return { Authorization: `Bearer ${token}` };
}

export async function generateReport(params: GenerateReportParams): Promise<ReportResponse> {
  if (params.format === 'csv') {
    await axios.post(`${API_BASE_URL}/api/analytics/reporting/generate`, params, {
      headers: authHeaders(),
      responseType: 'blob',
    });
    // Caller will handle blob download
    return { success: true, data: [], meta: { type: params.type, startDate: params.startDate, endDate: params.endDate } };
  }
  const res = await axios.post(`${API_BASE_URL}/api/analytics/reporting/generate`, params, { headers: authHeaders() });
  return res.data as ReportResponse;
}

export async function downloadCSV(params: GenerateReportParams): Promise<Blob> {
  const res = await axios.post(`${API_BASE_URL}/api/analytics/reporting/generate`, { ...params, format: 'csv' }, {
    headers: authHeaders(),
    responseType: 'blob',
  });
  return res.data as Blob;
}
